/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EmergencyCaseTrainingViewFilter } from './EmergencyCaseTrainingViewFilter';
import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';

export type EmergencyTeamTrainingViewRequest = {
    filter?: EmergencyCaseTrainingViewFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: EmergencyTeamTrainingViewRequest.exposeType;
}

export namespace EmergencyTeamTrainingViewRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
